import TuataraReptile from "../../assets/png/TuataraReptile.png";

const AboutBanner = () => {
  return (
    <>
      <div className="">
        <div className="relative">
          <img src={TuataraReptile} alt="" className="w-[-webkit-fill-available]" />
          <div
            className="
        bottom-0 
        absolute 
        text-[#F2F2F2CC] 
        font-extrabold
        font-[Rockwell]

        2xl:text-[180px]
        lg:text-[104px]
        md:text-[85px] 
        sm:text-[65px] 
        text-[33px] 

        2xl:leading-[132px]
        lg:leading-[74px]
        md:leading-[60px] 
        sm:leading-[47px] 
        leading-[25px]

        flex justify-center items-center w-[-webkit-fill-available] "
          >
            ABOUT TUATARA
          </div>
        </div>
      </div>
    </>
  );
};
export default AboutBanner;
